// Generated by GitHub Copilot
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ChevronLeft, LogOut } from 'lucide-react'
import { AuthGuard } from '#components/tools/auth-guard.tsx'
import { YnteqMark } from '#components/primitives/icons/ynteq-logo.tsx'

export const Route = createFileRoute('/settings')({
  component: RouteComponent,
})

/**
 * Company-less settings shell (`/settings/*`). Unlike the company-scoped
 * `/{companyId}/settings` area, this needs no company context — it hosts the
 * user's own account pages, reachable even when the account holds no company role.
 */
function RouteComponent() {
  const { t } = useTranslation('navigation')
  const { t: tSettings } = useTranslation('settings')

  return (
    <AuthGuard navigateToLoginOnFailure={true}>
      <div className="d-flex flex-column vh-100">
        <header className="ynt-topbar-bar">
          <Link to="/" className="ynt-inline-link-icon">
            <ChevronLeft className="flex-shrink-0" style={{ width: '1rem', height: '1rem' }} />
            <YnteqMark style={{ width: '1.25rem', height: '1.25rem' }} />
          </Link>
          <div className="flex-grow-1" />
          <Link to="/logout" className="ynt-inline-link-icon">
            <LogOut className="flex-shrink-0" style={{ width: '1rem', height: '1rem' }} />
            <span className="fw-normal">{t('appNav.logout')}</span>
          </Link>
        </header>

        <nav className="nav nav-underline px-4 border-bottom flex-shrink-0" aria-label={tSettings('nav.myAccountSettings')}>
          <Link to="/settings/user" className="nav-link" activeProps={{ className: 'active' }}>
            {tSettings('shared.fields.personalPreferences')}
          </Link>
          <Link to="/settings/security" className="nav-link" activeProps={{ className: 'active' }}>
            {tSettings('nav.security')}
          </Link>
        </nav>

        <div className="flex-grow-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </AuthGuard>
  )
}
